import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Politique de Confidentialité',
            description: 'Politique de confidentialité de Let\'s Try Bet',
          }),
        }}
      />

      <div className="min-h-screen pt-20">
        <section className="py-20">
          <div className="container mx-auto px-4 max-w-4xl">
            <h1 className="text-5xl font-bold text-white mb-4">
              Politique de Confidentialité
            </h1>
            <p className="text-dark-muted mb-8">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

            <div className="space-y-8 text-dark-muted leading-relaxed">
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">1. Introduction</h2>
                <p>
                  Let's Try Bet s'engage à protéger votre vie privée. Cette politique de
                  confidentialité explique comment nous collectons, utilisons et protégeons vos
                  informations personnelles lorsque vous utilisez notre site web.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">2. Données Collectées</h2>
                <p className="mb-3">Nous collectons les types de données suivants :</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Données de navigation (adresse IP, type de navigateur, pages visitées)</li>
                  <li>Cookies et technologies similaires</li>
                  <li>Informations fournies volontairement (formulaires de contact)</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">3. Utilisation des Données</h2>
                <p className="mb-3">Vos données sont utilisées pour :</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Améliorer votre expérience utilisateur</li>
                  <li>Analyser le trafic et l'utilisation du site</li>
                  <li>Personnaliser le contenu</li>
                  <li>Vous contacter si nécessaire</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">4. Partage des Données</h2>
                <p>
                  Nous ne vendons pas vos données personnelles. Nous pouvons partager certaines
                  informations avec des partenaires de confiance uniquement dans le cadre de
                  l'amélioration de nos services, et toujours dans le respect de votre vie privée.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">5. Vos Droits</h2>
                <p className="mb-3">Conformément au RGPD, vous avez le droit de :</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Accéder à vos données personnelles</li>
                  <li>Rectifier vos données</li>
                  <li>Supprimer vos données</li>
                  <li>Vous opposer au traitement</li>
                  <li>Portabilité des données</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">6. Sécurité</h2>
                <p>
                  Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos
                  données contre tout accès non autorisé, altération, divulgation ou destruction.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">7. Contact</h2>
                <p>
                  Pour toute question concernant cette politique de confidentialité, vous pouvez
                  nous contacter via notre formulaire de contact.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;

